import breakpoints from 'constants/breakpoints';
import styled from 'styled-components';

interface ContainerProps {
  isVisible: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: none;
  position: relative;

  @media (max-width: ${breakpoints.size.sm}px) {
    display: ${(props) => (props.isVisible ? 'flex' : 'none')};
  }
`;
